import { render, staticRenderFns } from "./textShadow.vue?vue&type=template&id=4070d2fa&"
import script from "./textShadow.vue?vue&type=script&lang=ts&"
export * from "./textShadow.vue?vue&type=script&lang=ts&"
import style0 from "./textShadow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports